import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import RefreshIcon from 'components/ReusableComponents/RefreshIcon'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import ReactTooltip from 'react-tooltip'
import subsidiariesApi from 'services/api/subsidiaries'

import ManagePlan from '../../ManagePlan'
import Box from '../Box/index'
import styles from './PrepayPreferences.module.scss'
import { SubscriptionsRow } from './SubscriptionsRow'

export const paymentPeriodOptions = {
  PostPay: 'Postpay',
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  SemiAnnual: 'Semi-Annual',
  Annual: 'Annual'
}

const PrepayPreferences = ({
  subscriptions,
  paymentPeriod,
  isInternalAdmin,
  hotelDetails,
  subsidiaryId
}) => {
  const [isManagePlanOpen, setIsManagePlanOpen] = useState(false)

  const [isLoading, setIsLoading] = useState(true)
  const [nearestStartDate, setNearestStartDate] = useState()

  const [isNotPrepay, setIsNotPrepay] = useState(false)

  useEffect(() => {
    subsidiariesApi.prepayPeriod
      .get()
      .then(res => {
        setNearestStartDate(res.nearestStartDate)
        setIsLoading(false)
      })
      .catch(() => {
        setIsNotPrepay(true)
        setIsLoading(false)
      })
  }, [])

  const sortedSubscriptions = useMemo(() => {
    return [...subscriptions].sort((a, b) => {
      const aIsActive = moment(a.startDate).isBefore(moment())
      const bIsActive = moment(b.startDate).isBefore(moment())

      if (aIsActive && !bIsActive) return -1
      if (!aIsActive && bIsActive) return 1
      return moment(a.addedOn).diff(moment(b.addedOn))
    })
  }, [subscriptions])

  const filteredSubscriptions = useMemo(() => {
    return sortedSubscriptions.filter(s => s.startDate !== s.endDate)
  }, [sortedSubscriptions])

  if (isLoading) {
    return <LoadingIndicator />
  }

  if (isNotPrepay) {
    return null
  }

  return (
    <Box title="Plan & Billing">
      <ReactTooltip place="top" type="dark" effect="solid" />
      <ManagePlan
        isOpen={isManagePlanOpen}
        onClose={() => setIsManagePlanOpen(false)}
        hotelDetails={hotelDetails}
        subsidiaryId={subsidiaryId}
      />

      {filteredSubscriptions.map(subscription => (
        <SubscriptionsRow
          {...subscription}
          key={subscription.plan}
          subscriptions={filteredSubscriptions}
        />
      ))}

      <div className={styles.paymentPeriodInfo}>
        <div className={styles.row}>
          <div className={styles.periodTitle}>
            <RefreshIcon className={styles.refreshIcon} />
            <div className={styles.label}>
              {paymentPeriodOptions[paymentPeriod]} Payment
            </div>
          </div>
        </div>
      </div>

      {isInternalAdmin && (
        <button
          onClick={() => setIsManagePlanOpen(true)}
          style={{
            width: '100%',
            marginTop: 16,
            padding: '10px',
            background: '#0079ff',
            color: '#fff',
            border: 'none',
            borderRadius: 3,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.15s'
          }}
        >
          Manage Plan
        </button>
      )}
    </Box>
  )
}

export default PrepayPreferences
